import React from "react";

interface SelectProps {
  id: any;
  idCnpj?:any;
  value: any;
  setCustomerData: any;
}

const TypePersonSelect: React.FC<SelectProps> = ({ id, value, setCustomerData, idCnpj }) => {

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
      const { id, value } = event.target;
      setCustomerData((prevForm: any) => ({
        ...prevForm,
        [id]: value,
        cnpj: "",
        ierg: "",
      }));
      
    };

  return (
    <div className="col-md-6 col-lg-4">
      <label>Tipo Pessoa</label>
      <select
        className="form-select"
        id={id}
        value={value}
        onChange={handleChange}
        disabled={idCnpj ? true : false}
      >
        <option value="FÍSICA">Pessoa Física</option>
        <option value="JURÍDICA">Pessoa Jurídica</option>
        <option value="stranger">Estrangeiro</option>
      </select>
    </div>
  )
}

export default TypePersonSelect